import { useState, useEffect } from "react";
import { useGlobalState } from "../contexts/GlobalStateContext";

const UpdateTitleModal = ({ onClose }) => {
  const [newTitle, setNewTitle] = useState("");
  const [charCount, setCharCount] = useState(0);
  const { globalState, logOut, setGlobalState, resetGlobalState } =
    useGlobalState();
  const maxLength = 55;

  useEffect(() => {
    if (!globalState.isAuthenticated) return;
    setNewTitle(globalState.user.title || "");
    setCharCount((globalState.user.title || "").length);
  }, [globalState.user.title, globalState.isAuthenticated]);

  const toTitleCase = (str) =>
    str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

  const handleChange = (e) => {
    const value = e.target.value.slice(0, maxLength);
    setNewTitle(value);
    setCharCount(value.length);
  };

  const updateTitle = async () => {
    const title = toTitleCase(newTitle.trim());

    try {
      const response = await fetch("/php/updateTitle.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newTitle: title }),
      });

      const result = await response.json();

      if (response.ok) {
        setGlobalState((prev) => ({
          ...prev,
          user: {
            ...prev.user,
            title: newTitle, // or toTitleCase(newTitle.trim()) if needed
          },
        }));

        onClose();
      } else if (result.status === "error") {
        logOut();
        resetGlobalState();
      } else {
        alert(result.message || "Failed to update title. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    }
  };
  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return (
    <div id="comments-modal" className="modal" style={{ display: "block" }}>
      <div className="w3-modal" style={{ display: "block" }}>
        <div className="update-title w3-animate-bottom">
          <header className="w3-container w3-teal">
            <div className="toggle_row">
              <div
                className="columnA"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "25px",
                }}
              >
                <span style={{ fontSize: "20px", marginLeft: "5px"  }}>Update Title</span>
                <span
                  onClick={onClose}
                  style={{
                    fontSize: "40px",
                    cursor: "pointer",
                    marginTop: isMobile ? "-7.5px" : "0px",
                  }}
                >
                  ×
                </span>
              </div>
            </div>
          </header>

          <div className="w3-container" style={{ margin: 10 }}>
            <input
              className="fullTextbox"
              type="text"
              value={newTitle}
              onChange={handleChange}
              placeholder="Enter new Status"
              maxLength={maxLength}
            />
            <div style={{ textAlign: "center", marginTop: 5 }}>
              <span
                id="titleCharCount"
                style={{ color: charCount >= maxLength ? "red" : "black" }}
              >
                {charCount}/{maxLength}
              </span>
            </div>
          </div>

          <div className="centered-buttons" style={{ margin: "20px 0" }}>
            <button style={{ backgroundColor: "gray" }} onClick={onClose}>
              Cancel
            </button>
            <button onClick={updateTitle}>Update</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateTitleModal;
